import React from 'react'
import { CustomInput } from '../../../../common/customInput/CustomInput'
import './AccountStyle.css'
import { CustomSpanComponent } from './Span-component/CustomSpanComponent'
import {phoneNumberFormat} from '../../../../../helper/phoneNumberFormat'
import logger from '../../../../../utils/logger'

export const AccountInfo = ({memberData}) => {

      logger.warn('memberData AccountInfo: ', memberData)

      return (
            <div className="mp-user-dto bg-mp-white">


                  <h4 className="mp-header-nav-title">Datos de contacto</h4>


                  <CustomSpanComponent
                        userData={memberData?.name}
                        label={'Nombre/s:'}
                  />

                  <CustomSpanComponent
                        userData={memberData?.lastname}
                        label={'Apellido/s:'}
                  />

                  <CustomSpanComponent
                        userData={phoneNumberFormat(memberData?.phoneNumber, memberData?.phonePrefix.prefix,true)}
                        label={'Teléfono:'}
                  />

                  <CustomSpanComponent
                        userData={memberData?.email}
                        label={'Email:'}
                  />

                  <CustomSpanComponent
                        userData={memberData?.documentType.description}
                        label={'Tipo de Documento:'}
                  />

                  <CustomSpanComponent
                        userData={memberData?.dni}
                        label={'Nro de Documento:'}
                  />

                  <CustomSpanComponent
                        userData={memberData?.profession.name}
                        label={'Profesión:'}
                  />

                  <CustomSpanComponent
                        userData={memberData?.professionalLicense}
                        label={'MP:'}
                  />


                  <CustomSpanComponent
                        userData={memberData?.address}
                        label={'Dirección:'}
                  />

                  <CustomSpanComponent
                        userData={memberData?.zipCode}
                        label={'Código Postal:'}
                  />

                  <CustomSpanComponent
                        userData={memberData?.addressAdditionalData}
                        label={'Barrio:'}
                  />

                  <CustomSpanComponent
                        userData={memberData?.city}
                        label={'localidad:'}
                  />


                  <CustomSpanComponent
                        userData={memberData?.province}
                        label={'Provincia:'}
                  />


                  <CustomSpanComponent
                        userData={memberData?.country}
                        label={'País:'}
                  />






                  {/* <div className="sc-buttons-1" id="actionButtons" >

        <button className="btn-save btn btn-success" id="saveButton" data-save="1">Guardar</button>
      </div> */}


            </div>
      )
}
